//React
import React, { useEffect, useState, useContext } from "react";

//Material
import { Grid, Switch, FormControlLabel } from "@material-ui/core";
import MaskService from "../../../../utils/mask/maskService";
import SelectErp from "../../../../components/basics/SelectErp";
import { FornecedorContext } from "../../../../pages/prouser/fornecedores/contexts/FornecedorContext";
import useFornecedorController from "../../../../pages/prouser/fornecedores/controllers/FornecedorController";
import TextFieldErp from "../../../../components/basics/TextFieldErp";

let temporizer = null;
const FormCadastroFornecedoresGeral = () => {
  const {
    //Geral
    geralCpfcnpj,
    setGeralCpfCnpj,
    geralRazao,
    setGeralRazao,
    geralFantasia,
    setGeralFantasia,
    geralCep,
    setGeralCEP,
    geralEndereco,
    setGeralEndereco,
    geralNumero,
    setGeralNumero,
    geralComplemento,
    setGeralComplemento,
    geralBairro,
    setGeralBairro,
    geralEstado,
    setGeralEstado,
    geralMunicipio,
    geralPais,
    setGeralPais,
    geralTel,
    setGeralTel,
    geralEmail,
    setGeralEmail,
    geralIe,
    setGeralIe,
    geralSm,
    setGeralSm,
    geralCf,
    setGeralCf,
    geralIm,
    setGeralIm,
    geralErrors,
    listUf,
    listCounty,
    listNation,
    geralAtivo,
    setGeralAtivo,
    IeIndication,
    setIeIndication,
    IeIndicationList,
    loadingInputs,
    geralCelular,
    setGeralCelular,
    geralWhatsappAtivo,
    setGeralWhatsappAtivo,
  } = useContext(FornecedorContext);

  const { handleCidade, handleNumInscricao, handleChangeCep } =
    useFornecedorController();

  const [ieIndicationOpen, setIeIndicationOpen] = useState(false);

  const handleInputUser = (e) => {
    let newInput = e.target.value.replaceAll(/[^0-9]/g, "");
    let mask;
    let updatedInput = newInput;

    if (newInput.length === 14) {
      mask = "cnpj";
      updatedInput = MaskService.toMask(mask, newInput);
    } else if (newInput.length === 11) {
      mask = "cpf";
      updatedInput = MaskService.toMask(mask, newInput);
    }
    setGeralCpfCnpj(updatedInput);

    clearTimeout(temporizer);
    temporizer = setTimeout(() => {
      handleNumInscricao(updatedInput);
    }, 1800);
  };

  useEffect(() => {
    if (IeIndication) {
      setIeIndicationOpen(true);
    }
  }, [IeIndication]);

  return (
    <Grid item xs={12}>
      <Grid container spacing={3}>
        <Grid item lg={4} md={3} sm={6} xs={12}>
          <TextFieldErp
            id="geralCpfcnpj"
            label="CPF, CNPJ ou CÓD*"
            value={geralCpfcnpj}
            setValue={setGeralCpfCnpj}
            onBlur={(e) => handleInputUser(e)}
            helperText={geralErrors.geralCpfcnpj || ""}
            error={!!geralErrors.geralCpfcnpj}
          />
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralRazao"
            label="Razão / Nome*"
            value={geralRazao}
            setValue={setGeralRazao}
            helperText={geralErrors.geralRazao || ""}
            error={!!geralErrors.geralRazao}
          />
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="fantasia"
            label="Fantasia*"
            value={geralFantasia}
            setValue={setGeralFantasia}
            helperText={geralErrors.geralFantasia || ""}
            error={!!geralErrors.geralFantasia}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralCep"
            label="CEP*"
            value={geralCep}
            setValue={setGeralCEP}
            helperText={geralErrors.geralCep || ""}
            error={!!geralErrors.geralCep}
            onChange={(value) => handleChangeCep(value, "general")}
          />
        </Grid>

        <Grid item lg={4} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="endereco"
            label="Endereço*"
            value={geralEndereco}
            setValue={setGeralEndereco}
            helperText={geralErrors.geralEndereco || ""}
            error={!!geralErrors.geralEndereco}
          />
        </Grid>
        <Grid item lg={1} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="numero"
            label="Número*"
            value={geralNumero}
            setValue={setGeralNumero}
            helperText={geralErrors.geralNumero || ""}
            error={!!geralErrors.geralNumero}
          />
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="complemento"
            label="Complemento"
            value={geralComplemento}
            setValue={setGeralComplemento}
            helperText={geralErrors.geralComplemento || ""}
            error={!!geralErrors.geralComplemento}
          />
        </Grid>

        <Grid item lg={3} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="bairro"
            label="Bairro*"
            value={geralBairro}
            setValue={setGeralBairro}
            helperText={geralErrors.geralBairro || ""}
            error={!!geralErrors.geralBairro}
          />
        </Grid>
        <Grid item lg={2} md={6} sm={6} xs={12}>
          <SelectErp
            id="geralEstado"
            label="Estado*"
            optionsList={listUf}
            loading={loadingInputs?.listUf || false}
            value={geralEstado}
            setValue={setGeralEstado}
            descriptionField="estado"
            helperText={geralErrors.geralEstado || ""}
            error={!!geralErrors.geralEstado}
          />
        </Grid>
        <Grid item lg={2} md={6} sm={6} xs={12}>
          <SelectErp
            id="geralMunicipio"
            loading={loadingInputs?.listCounty || false}
            label="Município*"
            value={geralMunicipio}
            onChange={handleCidade}
            optionsList={
              geralEstado
                ? listCounty.filter(
                    (opt) => opt.estado_codigo === geralEstado.codibge
                  )
                : []
            }
            descriptionField="municipio"
            helperText={geralErrors.geralMunicipio || ""}
            error={!!geralErrors.geralMunicipio}
          />
        </Grid>
        <Grid item lg={2} md={6} sm={6} xs={12}>
          <SelectErp
            loading={loadingInputs?.listNation || false}
            id="geralPais"
            label="País"
            optionsList={listNation}
            value={geralPais}
            setValue={setGeralPais}
            descriptionField="descricao"
            helperText={geralErrors.geralPais || ""}
            error={!!geralErrors.geralPais}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralTel"
            label="Telefone"
            value={geralTel}
            setValue={setGeralTel}
            helperText={geralErrors.geralTel || ""}
            error={!!geralErrors.geralTel}
            mask="cel-phone"
          />
        </Grid>

        <Grid item lg={3} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralEmail"
            label="Email"
            value={geralEmail}
            setValue={setGeralEmail}
            helperText={geralErrors.geralEmail || ""}
            error={!!geralErrors.geralEmail}
          />
        </Grid>
        <Grid item lg={2} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralIe"
            label="IE / RG"
            value={geralIe}
            setValue={setGeralIe}
            helperText={geralErrors.geralIe || ""}
            error={!!geralErrors.geralIe}
          />
        </Grid>
        <Grid item lg={2} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralIm"
            label="Inscrição Municipal"
            value={geralIm}
            setValue={setGeralIm}
            helperText={geralErrors.geralIm || ""}
            error={!!geralErrors.geralIm}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={6} xs={12}>
          <TextFieldErp
            id="geralCelular"
            label="Celular"
            value={geralCelular}
            setValue={setGeralCelular}
            mask="cel-phone"
          />
        </Grid>
        <Grid item lg={1} md={6} sm={6} xs={12}>
          <FormControlLabel
            value="end"
            control={
              <Switch
                checked={geralWhatsappAtivo}
                onChange={() => setGeralWhatsappAtivo((current) => !current)}
                color="primary"
              />
            }
            label="Whatsapp"
            labelPlacement="end"
          />
        </Grid>
        <Grid item container spacing={3}>
          <Grid item lg={2} md={6} sm={6} xs={12}>
            <FormControlLabel
              value="end"
              control={
                <Switch
                  checked={ieIndicationOpen}
                  onChange={() => setIeIndicationOpen((current) => !current)}
                  color="primary"
                />
              }
              label="Indicação IE?"
              labelPlacement="end"
            />
          </Grid>
          <Grid item lg={2} md={6} sm={6} xs={12}>
            <SelectErp
              disabled={!ieIndicationOpen}
              label="Indicação IE"
              value={IeIndication}
              setValue={setIeIndication}
              optionsList={IeIndicationList}
              descriptionField="description"
            />
          </Grid>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <FormControlLabel
              value="end"
              control={
                <Switch
                  checked={geralSm}
                  onChange={() => setGeralSm((current) => !current)}
                  color="primary"
                />
              }
              label="Optante pelo simples nacional"
              labelPlacement="end"
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <FormControlLabel
              value="end"
              control={
                <Switch
                  checked={geralCf}
                  onChange={() => setGeralCf((current) => !current)}
                  color="primary"
                />
              }
              label="Consumidor Final"
              labelPlacement="end"
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={geralAtivo}
                  onChange={() => setGeralAtivo((current) => !current)}
                  color="primary"
                />
              }
              label="Ativo"
              labelPlacement="end"
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FormCadastroFornecedoresGeral;
